import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Icon } from "semantic-ui-react";
import { styled, useTheme } from "styled-components";

import { formatDate, formatDateRelative } from "simplydo/core/dates";
import { getImageUrl } from "simplydo/core/images";
import { OpenAPI } from "simplydo/interfaces";

import { useAppSelector } from "store";
import util from "utils/utils";

const StyledAvatar = styled(Link)<{
  $subject: OpenAPI.Schemas["User"] | { name: string };
}>`
  position: relative;
  height: 30px !important;
  width: 30px !important;
  line-height: inherit;
  border-radius: 50%;
  display: inline-block;
  background-size: cover;
  background-position: center center;
  vertical-align: middle;
  margin-right: 5px;
  background-image: ${({ $subject }) =>
    `url(${util.mixinCssUrlFallback(
      $subject.name ?
        getImageUrl(
          $subject,
          "logo",
          ["200x200"],
          "images/defaults/profile-logo.png",
        )
      : util.avatarUrl($subject),
      util.avatarUrl(),
    )})`};
`;

const StyledCompanyLogo = styled.div<{ $company: OpenAPI.Schemas["Company"] }>`
  position: relative;
  height: 30px !important;
  width: 30px !important;
  line-height: inherit;
  border-radius: 50%;
  display: inline-block;
  background-size: cover;
  background-position: center center;
  vertical-align: middle;
  margin-right: 5px;
  background-image: ${({ $company }) =>
    `url(${$company?.images?.logo?.url || $company.imageUrl})`};
`;

export type FeedCardHeaderProps = {
  user: OpenAPI.Schemas["User"];
  action: string;
  date: string;
  subjectItem: string;
  ownerType: string;
  company: OpenAPI.Schemas["Company"];
  subjectItem2: string;
  subjectItem3: string;
};

const FeedCardHeader = ({
  user,
  action,
  date,
  subjectItem,
  ownerType,
  company,
  subjectItem2,
  subjectItem3,
}: FeedCardHeaderProps) => {
  const currentUser = useAppSelector((state) => state.user);
  const { t } = useTranslation();
  const theme = useTheme();
  const subject =
    user && currentUser && user._id === currentUser._id ?
      { ...currentUser }
    : user;
  let name = "";
  if (ownerType === "company") {
    name = company.data.creditsafe.legal_name || company.name;
  } else if (subject && !subject.profile && subject.name) {
    name = subject.name;
  } else if (subject?.profile) {
    name = subject.profile?.fullName || "Someone";
  } else name = t("generic.anonymous");
  return (
    <div style={{ width: "100%", color: "#000", paddingBottom: 0 }}>
      <div
        style={{
          float: "left",
          display: "flex",
          alignItems: "center",
          color: "gray",
          gap: 5,
          maxWidth: "90%",
        }}
      >
        {ownerType === "company" ?
          <StyledCompanyLogo $company={company} />
        : user ?
          <StyledAvatar
            $subject={subject}
            to={`/${subject.name ? "profiles" : "users"}/${subject._id}`}
            style={{ minWidth: 32, marginRight: 6, marginLeft: 3 }}
          />
        : <Icon
            size="large"
            name="user secret"
            style={{
              color: "rgb(150,150,150)",
              marginRight: 6,
              marginLeft: 3,
              minWidth: 32,
            }}
          />
        }
        {}
        {t(action, { name, subjectItem, subjectItem2, subjectItem3 })}
      </div>
      {!theme.sizes.isMobile && (
        <div
          style={{
            float: "right",
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
            lineHeight: 2.5,
            color: "rgb(180,180,180)",
            fontSize: 10,
          }}
          data-tooltip={formatDate(date, "HH:mm 'on' dd/MM/yy")}
        >
          {formatDateRelative(date, { addSuffix: true })}
        </div>
      )}
    </div>
  );
};

export default FeedCardHeader;
